package com.essntl.features.area.ui.allareas

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel

data class AllAreasState(
    val getAllAreas: State<List<AreaModel>> = State(),
)
